import { useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import useAuthStore from '../store/authStore';
import { PRIVILEGES as codes } from '../config/privilegeConstant';

const useLayoutState = () => {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const { user, institution, logout, privileges } = useAuthStore((state) => ({
    user: state.user,
    institution: state.institution,
    logout: state.logout,
    privileges: state.privileges,
  }));

  const handleLogout = useCallback(() => {
    logout();
    navigate('/');
  }, [logout, navigate]);

  const handleDrawerOpen = useCallback(() => setOpen(true), []);
  const handleDrawerClose = useCallback(() => setOpen(false), []);

  const allMenuItems = [
    { text: 'Dashboard', icon: 'dashboard', path: '/dashboard', privilege: codes.DASHBOARD_VIEW },
    { text: 'Questionnaire Analysis', icon: 'analytics', path: '/overall-analysis', privilege: codes.OVERALL_ANALYSIS_VIEW },
    { text: 'Admin-Test Analysis', icon: 'analytics', path: '/analysis', privilege: codes.OVERALL_ADMIN_TEST_ANALYTICS_VIEW },
  ];
  const menuItems = allMenuItems.filter(item => !item.privilege || privileges.includes(item.privilege));

  return {
    open,
    user,
    menuItems,
    handleLogout,
    handleDrawerOpen,
    handleDrawerClose,
    navigate,
  };
};

export default useLayoutState;
